import callApi from './backendService';
import { buildQueryUrlFromObject } from '../../helper/buildQueryUrlFromObject';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

export const getInvitation = (formData) => callApi({
  method: 'POST',
  endpoint: `${basePath}/invites/${formData.id}`,
  body: formData
});

export const getInvitations = (formData) => callApi({
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  endpoint: `${basePath}/invites?${buildQueryUrlFromObject(formData)}`
});
